export const LILITH_CONVERSATION_AI_FEATURE = 'lilith_conversation_ai';
export const LILITH_CONVERSATION_AI_CUSTOM_TOOLS_FEATURE =
  'lilith_conversation_ai_custom_tools';

export const LILITH_TEAM_ASSIST_CONVERSATION_ROUTES = Object.freeze([
  'inbox_conversation',
  'conversation_through_inbox',
  'conversations_through_label',
  'team_conversations_through_label',
  'conversations_through_folders',
  'conversation_through_mentions',
  'conversation_through_unattended',
  'conversation_through_participating',
  'inbox_view_conversation',
]);

export const isLilithTeamAssistConversationRoute = routeName =>
  LILITH_TEAM_ASSIST_CONVERSATION_ROUTES.includes(routeName);

export const isLilithTeamAssistAvailable = ({ accountEntitled }) =>
  Boolean(accountEntitled);

export const isLilithConversationAIMessage = (additionalAttributes = {}) =>
  additionalAttributes?.lilith_conversation_ai_response === true ||
  additionalAttributes?.lilithConversationAiResponse === true ||
  additionalAttributes?.lilith_conversation_ai_handoff === true ||
  additionalAttributes?.lilithConversationAiHandoff === true;

export const isLilithConversationAIMessageReportAvailable = ({
  accountEntitled,
  additionalAttributes = {},
}) =>
  Boolean(
    accountEntitled && isLilithConversationAIMessage(additionalAttributes)
  );

export const LILITH_SURFACES = Object.freeze([
  {
    key: 'overview',
    routeName: 'lilith_overview',
    labelKey: 'TEAM_LILITH.NAV.OVERVIEW',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.OVERVIEW',
    featureFlag: LILITH_CONVERSATION_AI_FEATURE,
    status: 'partial',
  },
  {
    key: 'faqs',
    routeName: 'lilith_faqs',
    labelKey: 'TEAM_LILITH.NAV.FAQS',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.FAQS',
    featureFlag: LILITH_CONVERSATION_AI_FEATURE,
    status: 'partial',
  },
  {
    key: 'documents',
    routeName: 'lilith_documents',
    labelKey: 'TEAM_LILITH.NAV.DOCUMENTS',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.DOCUMENTS',
    featureFlag: LILITH_CONVERSATION_AI_FEATURE,
    status: 'partial',
  },
  {
    key: 'scenarios',
    routeName: 'lilith_scenarios',
    labelKey: 'TEAM_LILITH.NAV.SCENARIOS',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.SCENARIOS',
    featureFlag: LILITH_CONVERSATION_AI_FEATURE,
    status: 'partial',
  },
  {
    key: 'playground',
    routeName: 'lilith_playground',
    labelKey: 'TEAM_LILITH.NAV.PLAYGROUND',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.PLAYGROUND',
    featureFlag: LILITH_CONVERSATION_AI_FEATURE,
    status: 'partial',
  },
  {
    key: 'inboxes',
    routeName: 'lilith_inboxes',
    labelKey: 'TEAM_LILITH.NAV.INBOXES',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.INBOXES',
    featureFlag: LILITH_CONVERSATION_AI_FEATURE,
    status: 'partial',
  },
  {
    key: 'tools',
    routeName: 'lilith_tools',
    labelKey: 'TEAM_LILITH.NAV.TOOLS',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.TOOLS',
    featureFlag: LILITH_CONVERSATION_AI_CUSTOM_TOOLS_FEATURE,
    status: 'partial',
  },
  {
    key: 'settings',
    routeName: 'lilith_settings',
    labelKey: 'TEAM_LILITH.NAV.SETTINGS',
    descriptionKey: 'TEAM_LILITH.WORKSPACE.SURFACES.SETTINGS',
    featureFlag: LILITH_CONVERSATION_AI_FEATURE,
    status: 'partial',
  },
]);

export const getAvailableLilithSurfaces = isFeatureEnabled =>
  LILITH_SURFACES.filter(
    surface =>
      !surface.featureFlag || Boolean(isFeatureEnabled(surface.featureFlag))
  );

export const resolveLilithSurface = (requestedKey, isFeatureEnabled) => {
  const available = getAvailableLilithSurfaces(isFeatureEnabled);
  return (
    available.find(surface => surface.key === requestedKey) ||
    available[0] ||
    null
  );
};
